var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2636 8.50086C10.6136 8.50064 8.21351 9.49045 6.36338 11.1003L2.76367 7.5L2.76293 16.5L11.7629 16.5007L8.14323 12.8804C9.53333 11.7206 11.3034 11.0007 13.2634 11.0009C16.8034 11.0012 19.8132 13.3114 20.8629 16.5015L23.233 15.7217C21.8433 11.5316 17.9136 8.50124 13.2636 8.50086Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo24Px);
export default __webpack_public_path__ + "static/media/undo_24px.be2952f532432b3d5f9baa2b438a91aa.svg";
export { ForwardRef as ReactComponent };